import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 31.8.",
  "description": "",
  "published": "2011-08-31T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-31-8/swizec/2322"],
  "categories": "Arts, IPad, Learning, Moleskine, Personal, Time management, Writers Resources",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Moleskine_-_023.jpg",
        "alt": "Moleskine notebook and diaries.",
        "title": "Moleskine notebook and diaries."
      }}></img></p>
    <p>{`Today I learned that `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-30-8/swizec/2308",
        "title": "I learned two things today 30.8."
      }}>{`yesterday's post`}</a>{` where I spoke about the wonderful statics textbook that architects use it sounded a bit like a scathing review not only of the book itself, but the people reading it and that this was a bit ... unkind, even mean.`}</p>
    <p>{`To be honest, all that stuff I just found funny, there was actually a lot of interesting new things in the book as well. Like did you know wood only burns at a pace of 0.6mm per minute, retains core structural integrity and that despite being the most flammable building material is still the best thing for a fire due to poor `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Thermal_conductivity",
        "title": "Thermal conductivity"
      }}>{`heat conductivity`}</a>{` and that it doesn't collapse under heat like metals do? Or become brittle like concrete?`}</p>
    <p>{`And ... uhm ... some complex stuff about why things stand up and how all of that works.`}</p>
    <p>{`Another thing that I learned was that the Official `}<a parentName="p" {...{
        "href": "http://itunes.apple.com/us/app/moleskine/id429657255?mt=8"
      }}>{`Moleskine iPad App`}</a>{` is `}<em parentName="p">{`crap`}</em>{`. Was writing a rather lengthy blogpost last night - I find it easier to draft these things up somewhere other than the blog. Especially the more proper ones. After two hours of writing I pressed a button and the whole post vanished.`}</p>
    <p>{`No ability to get it back or anything.`}</p>
    <p>{`Moleskine iPad App ... you do `}<em parentName="p">{`not`}</em>{` behave like a notebook! Why can't you be as awesome as a real `}<a parentName="p" {...{
        "href": "http://www.moleskine.com/"
      }}>{`Moleskine`}</a>{`?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://rohdesign.com/weblog/2006/5/24/creating-a-custom-moleskine-planner.html"
        }}>{`Creating a Custom Moleskine Planner - Rohdesign Weblog - Designer Mike Rohde`}</a>{` (rohdesign.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://purplepomelo.wordpress.com/2011/08/20/the-power-of-gratitude/"
        }}>{`The Power of Gratitude`}</a>{` (purplepomelo.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://presentsofmind.wordpress.com/2011/08/27/my-notebook-obsession/"
        }}>{`My Notebook Obsession`}</a>{` (presentsofmind.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://rpgcharacters.wordpress.com/2011/08/06/more-moleskine-geomorphs/"
        }}>{`More Moleskine Geomorphs from A Character For Every Game`}</a>{` (rpgcharacters.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=313e2c4a-cba1-47da-93d2-c6d7cef0fd99",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      